<script setup lang="ts">
import { getCssCustomPropertyValue } from '../../helpers/cssCustomProperties';

interface OverlayProps {
  isModal: boolean;
  position?: 'fixed' | 'absolute';
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<OverlayProps>(), {
  position: 'fixed',
  height: '100dvh',
  width: '100vw',
  isModal: false,
});
const modalZIndex = getCssCustomPropertyValue('modal-overlay-z-index');
const defaultZIndex = '12';
</script>

<template>
  <div
    :style="{
      position: props.position,
      width: props.width,
      height: props.height,
      'z-index': props.isModal ? modalZIndex : defaultZIndex,
    }"
    class="app-overlay"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '../../styles/media';

.app-overlay {
  top: 0;
  left: 0;
  display: flex;
  background-color: var(--color-overlay);
  overflow: auto;
  overflow: overlay;
  box-sizing: border-box;
  justify-content: center;
  align-items: center;
  padding: var(--spacing-24);
  min-height: -webkit-fill-available;

  @include for-medium-devices-max {
    padding: 0;
  }
}
</style>
